import { MessagesPage } from '@openeducation/oe-it-teacher-portal';
import * as React from 'react';

export const MessagesScreen = () => {
  return <MessagesPage />;
};
